import { Tooltip } from 'antd';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { IconSvg } from 'shared/icon';
import { useAppSelector } from 'store/hooks';

import { selectUserConfigIsNightMode } from 'app/userPreferences/selectors';
import { useCreateOrEditUserConfigMutation } from 'app/userPreferences/api';
import { StyledAnimationModeSun, StyledListItemHeader } from 'app/layout/components/Layout.styled';

const ThemeColorsMode = () => {
  const isNightMode = useAppSelector(selectUserConfigIsNightMode);
  const { t } = useTranslation();
  const [createOrEditUserConfig] = useCreateOrEditUserConfigMutation();
  const { colors } = useTheme();

  const changeNightMode = () => {
    createOrEditUserConfig({ key: 'isNightMode', configValue: !isNightMode });
  };

  return (
    <StyledListItemHeader onClick={changeNightMode}>
      {isNightMode ? (
        <Tooltip placement="bottom" title={t('lightMode')}>
          <StyledAnimationModeSun>
            <IconSvg icon="BrightnessIcon" color={colors.white} />
          </StyledAnimationModeSun>
        </Tooltip>
      ) : (
        <div>
          <Tooltip placement="bottom" title={t('nightMode')}>
            <div>
              <IconSvg icon="NightModeIcon" width="1.14rem" height="1.14rem" color={colors.white} />
            </div>
          </Tooltip>
        </div>
      )}
    </StyledListItemHeader>
  );
};

export default ThemeColorsMode;
